import type { CSSProperties } from "react";
import type { V2Scene } from "../types";

const intensity: Record<V2Scene, { water: number; fog: number; light: number }> = {
  intro: { water: .12, fog: .32, light: .08 }, question: { water: .14, fog: .24, light: .1 },
  first: { water: .16, fog: .13, light: .12 }, struggle: { water: .18, fog: .11, light: .17 },
  dedication: { water: .07, fog: .3, light: .08 }, reflection: { water: .035, fog: .08, light: .18 },
  theory: { water: .03, fog: .06, light: .2 },
  jiaxing: { water: .08, fog: .035, light: .34 }, action: { water: .09, fog: .015, light: .48 },
  ticket: { water: .08, fog: .02, light: .54 }, lights: { water: .04, fog: .01, light: .66 },
  end: { water: .025, fog: 0, light: .7 },
};

export function EnvironmentOverlay({ scene, pulse = false }: { scene: V2Scene; pulse?: boolean }) {
  const values = intensity[scene];
  const style = { "--water-opacity": values.water, "--fog-opacity": values.fog, "--light-opacity": values.light } as CSSProperties;
  return (
    <div className={`v2-environment ${pulse ? "has-pulse" : ""}`} style={style} aria-hidden="true">
      <div className="v2-ambient-light" />
      <div className="v2-ambient-fog is-back" />
      <div className="v2-ambient-fog is-front" />
      <div className="v2-ambient-water"><i /><i /><i /></div>
      <div className="v2-ripple"><i /><i /></div>
      <div className="v2-mist-flash" />
    </div>
  );
}
